import { Component, Input, OnInit } from '@angular/core';
import { GridRegistrationModel } from '@bo-client/activation-management/grid-registration/model/grid-registration.model';
import {
  NaProtectionTypeEnum,
  SymmetryConditionsEnum
} from '@bo-client/activation-management/grid-registration/model/grid-registration.enum';
import { MetaService } from '@bo-client/core/api/meta-service';
import { map, shareReplay, takeUntil } from 'rxjs/operators';
import { of, Subject } from 'rxjs';
import { DataShareService } from '@bo-client/shared/services/data-share.service';

@Component({
  selector: 'app-gr-place-in-service-feeder-summary',
  templateUrl: './gr-place-in-service-feeder-summary.component.html',
  styleUrls: ['../../../../shared/summaries/css-summary.component.scss']
})
export class GrPlaceInServiceFeederSummaryComponent implements OnInit {
  @Input() gr: GridRegistrationModel;

  protected totalActivePower = 0;
  protected totalApparentPower = 0;
  protected totalModulePower = 0;

  protected naProtectionTypeEnum = NaProtectionTypeEnum;
  protected symmetryConditionsEnum = SymmetryConditionsEnum;

  showExternalIdField$ = of(false);
  showExternalCustomerIdField$ = of(false);

  private ngUnsubscribe$ = new Subject<void>();

  get hasMeterValues() {
    return this.gr.meterNumber && this.gr.meterOne?.value;
  }

  constructor(protected metaService: MetaService, private dataShareService: DataShareService) {
    // Empty
  }

  ngOnInit(): void {
    this.initShowExternalIdFields();
    if (this.gr.producers && this.gr.producers.length > 0) {
      this.gr.producers.forEach((x) => {
        this.totalActivePower = this.totalActivePower + x.acActivePowerMax * x.count;
        this.totalApparentPower = this.totalApparentPower + x.acApparentPowerMax * x.count;
      });
    }
    if (this.gr.pvModules && this.gr.pvModules.length > 0) {
      this.gr.pvModules.forEach((x) => {
        this.totalModulePower = this.totalModulePower + x.modulePowerWatt * x.count;
      });
    }
  }

  private initShowExternalIdFields() {
    const config$ = this.dataShareService.tenantConfig$.pipe(
      takeUntil(this.ngUnsubscribe$),
      map((config) => config?.gridRegistration),
      shareReplay(1)
    );
    this.showExternalIdField$ = config$.pipe(map((config) => !!config?.showExternalIdField));
    this.showExternalCustomerIdField$ = config$.pipe(map((config) => !!config?.showExternalCustomerIdField));
  }
}
